import "./team.scss"

const Team = () => {
    return (
        <div>
            Team
        </div>
    );
}
 
export default Team;